import { render, staticRenderFns } from "./MyDownloadablePacksList.vue?vue&type=template&id=2b3e5fcd"
import script from "./MyDownloadablePacksList.vue?vue&type=script&lang=js"
export * from "./MyDownloadablePacksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports